import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  Exercicio, ExercicioService,
  FuncaoService, GlobalService, LoginContabil,
  OrgaoService
} from 'eddydata-lib';
import { SelectItem } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BalancoService } from './service/balanco.service';
import { Anexo12Balanco } from './anexo-12/anexo12.balanco';
import { Anexo121Balanco } from './anexo-12-1/anexo12.1.balanco';
import { Anexo122Balanco } from './anexo-12-2/anexo12.2.balanco';
import { Anexo13Balanco } from './anexo-13/anexo-13.balanco';
import { Anexo13ABalanco } from './anexo-13-A/anexo-13.A.balanco';
import { Anexo14Balanco } from './anexo-14/anexo-14.balanco';
import { Anexo14ABalanco } from './anexo-14-A/anexo14.A.balanco';
import { Anexo14BBalanco } from './anexo-14-B/anexo14.B.balanco';
import { Anexo15Balanco } from './anexo-15/anexo-15.balanco';

@Component({
  selector: 'lib-balanco',
  templateUrl: './balanco.component.html'
})
export class BalancoComponent implements OnInit, OnDestroy {

  public login: LoginContabil = new LoginContabil();
  public exercicioSelect: Exercicio;
  public listaOrgaos: SelectItem[];
  public orgaos: number[] = [];
  public listaExercicios: Array<any>;
  public balanceteSelect = 'BR';
  public listaBalancetes: Array<any>;
  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    private router: Router,
    protected balancoServico: BalancoService,
    protected exercicioService: ExercicioService,
    protected orgaoService: OrgaoService,
    protected funcaoService: FuncaoService) {
    this.login = GlobalService.obterSessaoLogin();
    this.exercicioSelect = this.login.exercicio;
    this.orgaos.push(this.login.orgao.id);
  }

  ngOnInit() {
    this.orgaoService.obterTodos()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        this.listaOrgaos = [];
        for (const model of dados) {
          this.listaOrgaos.push({ label: `${model.codigo} - ${model.nome}`, value: model.id });
        }
      });
    this.exercicioService.obterTodosOrdenadoPorAno(this.login.cidade.id).pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        this.listaExercicios = new Array();
        const lista = dados.content;
        for (const exercicio of lista as Array<Exercicio>) {
          this.listaExercicios.push({ id: exercicio.id, ano: exercicio.ano });
        }
      });
    this.listaBalancetes = [
      { id: 'B12', nome: 'ANEXO 12 - BALANÇO ORÇAMENTÁRIO' },
      { id: 'B121', nome: 'ANEXO 12.1 - DEMONSTRATIVO DE EXECUÇÃO DE RESTOS A PAGAR NÃO PROCESSADO' },
      { id: 'B122', nome: 'ANEXO 12.2  - DEMONSTRATIVO DE EXECUÇÃO DE RESTOS A PAGAR PROCESSADO' },
      { id: 'B13', nome: 'ANEXO 13 - BALANÇO FINANCEIRO' },
      { id: 'B13A', nome: 'ANEXO 13 A - BALANÇO FINANCEIRO' },
      { id: 'B14', nome: 'ANEXO 14 - BALANÇO PATRIMONIAL' },
      { id: 'B14A', nome: 'ANEXO 14 A - QUADRO DEMONSTRATIVO DAS CONTAS ANALÍTICAS DO ATIVO FINANCEIRO' },
      { id: 'B14B', nome: 'ANEXO 14 B - QUADRO DEMONSTRATIVO DAS CONTAS ANALÍTICAS DO PASSIVO FINANCEIRO' },
      { id: 'B15', nome: 'ANEXO 15 - DEMONSTRAÇÃO DAS VARIAÇÕES PATRIMONIAIS' },
    ];
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  imprimir() {
    if (this.orgaos && this.orgaos.length > 0) {
      if (this.balanceteSelect === 'B12') {
        const a12 = new Anexo12Balanco(this.balancoServico, this.exercicioSelect);
        a12.montarRelatorio(this.orgaos);
      } else if (this.balanceteSelect === 'B121') {
        const a121 = new Anexo121Balanco(this.balancoServico, this.exercicioSelect);
        a121.montarRelatorio(this.exercicioSelect, this.orgaos);
      } else if (this.balanceteSelect === 'B122') {
        const a122 = new Anexo122Balanco(this.balancoServico, this.exercicioSelect);
        a122.montarRelatorio(this.exercicioSelect, this.orgaos);
      } else if (this.balanceteSelect === 'B13') {
        const a13 = new Anexo13Balanco(this.balancoServico);
        a13.montarRelatorio(this.exercicioSelect, this.orgaos);
      } else if (this.balanceteSelect === 'B13A') {
        const a13A = new Anexo13ABalanco(this.balancoServico);
        a13A.montarRelatorio(this.exercicioSelect, this.orgaos);
      } else if (this.balanceteSelect === 'B14') {
        const a14 = new Anexo14Balanco(this.balancoServico);
        a14.montarRelatorio(this.exercicioSelect, this.orgaos);
      } else if (this.balanceteSelect === 'B14A') {
        const a14A = new Anexo14ABalanco(this.balancoServico, this.exercicioSelect);
        a14A.montarRelatorio(this.exercicioSelect, this.orgaos);
      } else if (this.balanceteSelect === 'B14B') {
        const a14B = new Anexo14BBalanco(this.balancoServico, this.exercicioSelect);
        a14B.montarRelatorio(this.exercicioSelect, this.orgaos);
      } else if (this.balanceteSelect === 'B15') {
        const a15 = new Anexo15Balanco(this.balancoServico);
        a15.montarRelatorio(this.exercicioSelect, this.orgaos);
      } else {
        toastr.warning('Selecione o anexo a ser impresso');
      }
    } else {
      toastr.warning('Selecione o(s) órgão(s) a serem impressos');
    }
  }

  sair() {
    this.funcaoService.navegarPara(this.login.usuario.sistema, this.router);
  }

  /**
  * Método para verificação de objetos, usados em combos `<select>`
  */
  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 && c1.id && c2.id ? c1.id === c2.id : c1 === c2;
  }

  public voltar() {
    switch (this.login.sistema) {
      case 'contabil':
      case 'controle-interno':
        this.router.navigate(['/contabilidade']);
        break;
      default:
        this.sair();
        break;
    }
  }

}
